import { Switch } from "@/shared/ui/switch";
import { Label } from "@/shared/ui/label";
import { DatePickerField } from "./DatePickerField";
import { useTranslation } from "@/shared/i18n";

interface VipFieldProps {
  vip: boolean;
  onVipChange: (checked: boolean) => void;
  vipExpiresAt: Date | null;
  onVipExpiresAtChange: (date: Date | null) => void;
  formErrors: { [key: string]: string };
}

export function VipField({
  vip,
  onVipChange,
  vipExpiresAt,
  onVipExpiresAtChange,
  formErrors,
}: VipFieldProps) {
  const { t } = useTranslation('profiles');
  return (
    <div className="flex items-start gap-8">
      <div className="w-[320px]">
        <div className="flex items-center justify-between mb-2">
          <Label htmlFor="vip" className="text-white text-base">
            {t('vipLabel')}
          </Label>
          <Switch
            id="vip"
            checked={vip}
            onCheckedChange={onVipChange}
            className="data-[state=checked]:bg-[#1677FF]"
          />
        </div>
        <DatePickerField
          label={t('vipLabel')}
          sublabel={t('vipExpiresAtLabel')}
          date={vipExpiresAt}
          onDateChange={onVipExpiresAtChange}
        />
        {formErrors.vipExpiresAt && (
          <p className="text-sm text-red-500">{formErrors.vipExpiresAt}</p>
        )}
      </div>
    </div>
  );
}
